import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Greetings from './pages/Greetings';
import Restaurants from './pages/Restaurants';
import Movies from './pages/Movies';
import TrainStation from './pages/TrainStation';
import Shopping from './pages/Shopping';
import Travel from './pages/Travel';
import Emergency from './pages/Emergency';
import Socialising from './pages/Socialising';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/greetings" element={<Greetings />} />
        <Route path="/restaurants" element={<Restaurants />} />
        <Route path="/movies" element={<Movies />} />
        <Route path="/train-station" element={<TrainStation />} />
        <Route path="/shopping" element={<Shopping />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/emergency" element={<Emergency />} />
        <Route path="/socialising" element={<Socialising />} />
      </Routes>
    </Router>
  );
};

export default App;
